import { useEffect, useState } from 'react'

export function useLocalStorage(key, fallback?: any, conversionFunc?: any) {
  const [storageItem, setStorageItem] = useState(() => {
    const val = localStorage.getItem(key)
    const result = conversionFunc && val !== null ? conversionFunc(val) : val
    if (result === null || result === undefined) return fallback
    try {
      if (typeof result === 'string' && (result.startsWith('[') || result.startsWith('{'))) {
        return JSON.parse(result)
      }
    } catch {
      // something happened, that shouldnt have happened,  reset
    }
    return result
  })

  useEffect(() => {
    const valToStore =
      typeof storageItem === 'object' && storageItem !== null ? JSON.stringify(storageItem) : storageItem
    if (valToStore !== null && valToStore !== undefined) {
      localStorage.setItem(key, valToStore)
    }
  }, [key, storageItem])

  return [storageItem, setStorageItem]
}
